export default __webpack_public_path__ + "static/media/globo_footer.3bae2a4b.svg";